module.exports = __webpack_public_path__ + "assets/img/terminalPic2_app.a8ae6950.png";